









































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AcgnFormContent, AcgnFormTitle, AcgnProcedureEdit } from '@/components/';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';
import { Popover } from 'element-ui';

const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;

interface ComicFlowType { // 编辑结构类型
  name: string; // 名称
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnUpload,
    AcgnProcedureEdit,
    [Popover.name]: Popover
  }
})

/**
 * 项目编辑
 */
export default class ComicEdit extends Vue {

  @ComicAction private getTemplate: any; // 默认环节
  @ComicAction private sortTemplateLink: any; // 环节排序
  @ComicAction private updateComic: any; // 编辑漫画
  @ComicGetter private loadings: any; // 漫画loading

  private formData: ComicFlowType = {
    name: ''
  };
  private workflowList: any = [];
  private newworkflowList: any = [];
  private isSort: any = false;
  private timeunitlist = [
    {
      value: 0,
      label: '小时'
    },
    {
      value: 1,
      label: '天'
    },
  ];

  // 获取新的排序值
  private getNewWork(data: any) {
    this.newworkflowList = data;
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ]
    };

    return rules;
  }

  // 排序
  private async getSort() {
    this.isSort = !this.isSort;
    if (!this.isSort) {
      this.newworkflowList.map((i: any, j: any) => {
        i.orders = j + 1;
      });
      const {result} = await this.sortTemplateLink({templateList: this.newworkflowList});
    }
  }

  // 保存
  private async submit() {
    this.newworkflowList.map((i: any, j: any) => {
      i.orders = j + 1;
    });
    const {result} = await this.sortTemplateLink({templateList: this.newworkflowList});
    this.$message.success('保存成功');
  }

  // 流程设置
  private async getFlowList() {
    const { result } = await this.getTemplate({project_type: 1});
    this.workflowList = result;
    this.newworkflowList = result;
  }

  private created() {
    this.getFlowList();
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
